export default __webpack_public_path__ + "fdeef55857f9406b4556bc0d055d2951.jpg";